module.exports = __webpack_public_path__ + "img/ippy-logo.dbd0c08.svg";